const TOKEN_KEY = 'auth_token';
const USER_KEY = 'user_data';

export const StorageService = {
    setToken(token: string) {
        localStorage.setItem(TOKEN_KEY, token);
    },

    getToken(): string | null {
        return localStorage.getItem(TOKEN_KEY);
    },

    setUser(user: string) {
        localStorage.setItem(USER_KEY, user);
    },

    getUser(): string | null {
        return localStorage.getItem(USER_KEY);
    },

    clearStorage() {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
    }
}; 